import React from 'react';
import PropTypes from 'prop-types';

import ReactPaginate from 'react-paginate';

const KNPagination = (props) => {

    const containerClassName = props?.containerClassName ? props.containerClassName : 'pagination';
    const activeClassName = props?.activeClassName ? props.activeClassName : 'active';

    return (
        <div>
            {
                props.pageCount ? (
                    <>
                        <section className="flex items-center sm:justify-between justify-center">
                            <section className="sm:flex-1 sm:flex sm:items-center sm:justify-between flex-wrap">
                                <div>
                                    <p className="text-sm text-gray-700 mb-3">
                                        Showing
                                        <span className="font-medium"> {props.skipStart} </span>
                                        to
                                        <span className="font-medium"> {props.skipEnd} </span>
                                        of
                                        <span className="font-medium"> {props.totalCount} </span>
                                        results
                                    </p>
                                </div>
                                <div className="sm:text-left text-center">
                                    <ReactPaginate
                                        previousLabel={
                                            <>
                                                <span className="sr-only">Previous</span>
                                                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                                                </svg>
                                            </>
                                        }
                                        nextLabel={
                                            <>
                                                <span className="sr-only">Next</span>
                                                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                                </svg>
                                            </>
                                        }
                                        initialPage={ props?.initialPage ? props.initialPage : undefined }
                                        pageCount={props.pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={props.handlePageClick}
                                        containerClassName={containerClassName}
                                        activeClassName={activeClassName}
                                    />
                                </div>
                            </section>

                        </section>
                    </>
                ) : null
            }
        </div>
    );
};

KNPagination.propTypes = {

    pageCount: PropTypes.number.isRequired,
    skipStart: PropTypes.number.isRequired,
    skipEnd: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
    initialPage: PropTypes.number,
    handlePageClick: PropTypes.func,

    containerClassName: PropTypes.string,
    activeClassName: PropTypes.string,
};

export default KNPagination;